<p-dialog [(visible)]="selfieVerifyDialog" (onHide)="close()" [modal]="true" styleClass="cus-dialog-lg cus-dialog dark-dialog"
  [draggable]="false" [resizable]="false">
  <!-- If you dont want dialod close button then add no-exit class in above -->
  <div *ngIf="true" class="dark-content selfie-dialog">
    <div class="dark-inner">
      <div class="gradient-line"></div>
      <div class="dark-left">
        <ng-lottie [options]="options"></ng-lottie>
      </div>
      <!-- Initial Content -->
      <div *ngIf="uploadSelfieStatus.selfieUploading" class="dark-right">
        <div class="dark-inn-title"><span class="highlight">Uploading & <span class="wrap-text">Verifying</span></span>
          applicant’s selfie</div>
        <div class="dark-inn-info">This will take just a moment.</div>
      </div>
      <!-- Optional Deviation Content 1-->
      <div *ngIf="uploadSelfieStatus.waitingScreen" class="dark-right">
        <div class="dark-inn-title">Please give us a <span class="highlight-secondary wrap-text">little more time</span>
        </div>
        <div class="dark-inn-info">Thank you for choosing us. Your application has <span class="wrap-text">been
            submitted successfully. We are verifying</span> your application, give us some time.</div>
      </div>
      <!-- Optional Deviation Content 2-->
      <div  *ngIf="uploadSelfieStatus.waitingScreen2" class="dark-right">
        <div class="dark-inn-title">Please give us a <span class="highlight-secondary wrap-text">little more time</span>
        </div>
        <div class="dark-inn-info">Thank you for choosing us. Your application has <span class="wrap-text">been
            submitted successfully. We are verifying</span> your application, will notify you shortly.</div>
        <button class="btn-theme" (click)="close()">Back to Home</button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="guardianFlowPopup" [modal]="true" styleClass="cus-dialog-lg cus-dialog dark-dialog"
  [draggable]="false" [resizable]="false">
  <!-- If you dont want dialod close button then add no-exit class in above -->
  <!-- Guardian Confirm -->
  <div class="dark-content guardian-dialog">
    <div class="dark-inner">
      <div class="gradient-line"></div>
      <div class="dark-left">
        <img src="assets/images/dialog/guardian_info.svg" alt="Guardian Image" />
      </div>
      <div class="dark-right">
        <div class="dark-inn-title"><span class="highlight">Parent/Guardian</span> <span class="wrap-text">will be the
            Applicant</span></div>
        <div class="dark-inn-info">who will be filling the application, they <span class="wrap-text">will assume
            responsibility for</span> repaying the loan</div>
      </div>
    </div>
  </div>
</p-dialog>